<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#000" d="M7 17c-1.101 0-2-.9-2-2V3h10v14H7z"/>
  <path stroke="#000" d="M19 5v16H7"/>
</svg>
